import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field, PasswordInput, UsernameInput, validPassword } from "@/pages/register/Fields";

export function PersonalStep({ form, set, withFonction }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Field label="Prénom" required><Input className="h-12" value={form.prenom} onChange={(e) => set({ prenom: e.target.value })} data-testid="reg-prenom" /></Field>
      <Field label="Nom" required><Input className="h-12" value={form.nom} onChange={(e) => set({ nom: e.target.value })} data-testid="reg-nom" /></Field>
      <Field label="Sexe" required>
        <Select value={form.sexe} onValueChange={(v) => set({ sexe: v })}>
          <SelectTrigger className="h-12" data-testid="reg-sexe"><SelectValue placeholder="Choisir" /></SelectTrigger>
          <SelectContent><SelectItem value="M">Masculin</SelectItem><SelectItem value="F">Féminin</SelectItem></SelectContent>
        </Select>
      </Field>
      <Field label="Téléphone" required><Input className="h-12" type="tel" inputMode="tel" value={form.telephone} onChange={(e) => set({ telephone: e.target.value })} placeholder="77 123 45 67" data-testid="reg-telephone" /></Field>
      <Field label="Adresse e-mail" hint="Facultatif"><Input className="h-12" type="email" value={form.email} onChange={(e) => set({ email: e.target.value })} data-testid="reg-email" /></Field>
      {withFonction && (
        <Field label="Fonction" required><Input className="h-12" value={form.fonction} onChange={(e) => set({ fonction: e.target.value })} placeholder="ex : Directeur, Directrice, Chargé d'école" data-testid="reg-fonction" /></Field>
      )}
    </div>
  );
}

export function CredentialsStep({ form, set, withRecovery }) {
  const mismatch = form.password2 && form.password !== form.password2;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Field label="Identifiant de connexion" required className="sm:col-span-2" hint="Vous l'utiliserez pour vous connecter. Lettres, chiffres, point, tiret.">
        <UsernameInput value={form.username} onChange={(v) => set({ username: v })} onStatus={(ok) => set({ usernameOk: ok })} />
      </Field>
      {withRecovery && (
        <Field label="E-mail de récupération" hint="Facultatif" className="sm:col-span-2">
          <Input className="h-12" type="email" value={form.recovery_email} onChange={(e) => set({ recovery_email: e.target.value })} data-testid="reg-recovery-email" />
        </Field>
      )}
      <Field label="Mot de passe" required hint="8 caractères minimum, avec au moins une lettre et un chiffre.">
        <PasswordInput value={form.password} onChange={(v) => set({ password: v })} testid="reg-password" />
      </Field>
      <Field label="Confirmer le mot de passe" required>
        <PasswordInput value={form.password2} onChange={(v) => set({ password2: v })} testid="reg-password2" />
        {mismatch && <p className="text-xs text-red-600 mt-1">Les mots de passe ne correspondent pas.</p>}
      </Field>
    </div>
  );
}

export function validatePersonal(f, withFonction) {
  if (!f.prenom.trim() || !f.nom.trim()) return "Renseignez votre prénom et votre nom.";
  if (!f.sexe) return "Indiquez votre sexe.";
  if (f.telephone.replace(/\D/g, "").length < 7) return "Numéro de téléphone invalide.";
  if (f.email && !/^\S+@\S+\.\S+$/.test(f.email)) return "Adresse e-mail invalide.";
  if (withFonction && !f.fonction.trim()) return "Indiquez votre fonction.";
  return null;
}

export function validateCredentials(f) {
  if (!f.username || f.username.length < 3) return "Choisissez un identifiant (3 caractères minimum).";
  if (f.usernameOk === false) return "Cet identifiant est déjà utilisé.";
  if (f.recovery_email && !/^\S+@\S+\.\S+$/.test(f.recovery_email)) return "E-mail de récupération invalide.";
  if (!validPassword(f.password)) return "Mot de passe trop faible : 8 caractères, une lettre et un chiffre minimum.";
  if (f.password !== f.password2) return "Les mots de passe ne correspondent pas.";
  return null;
}
